import HttpFactory from "~/repository/factory";
import type {
  SchoolInterest,
  SchoolInterestInput,
  SchoolInterestListFilters,
  SchoolInterestPage,
  SchoolInterestCatalogs,
  SchoolInterestLevel,
  SchoolInterestLevelInput,
  SchoolInterestStage,
  SchoolInterestStageInput,
  SchoolInterestActivity,
  SchoolInterestActivityInput,
} from "~/types/schoolInterests";

const interests = "/api/organizations/current/interests/";

export default class SchoolInterestsModule extends HttpFactory {
  list(filters: Partial<SchoolInterestListFilters> = {}) {
    return this.get<SchoolInterestPage>(interests, { ...filters });
  }

  getInterest(id: number) {
    return this.get<SchoolInterest>(`${interests}${id}/`);
  }

  createInterest(input: SchoolInterestInput) {
    return this.post<SchoolInterest>(interests, input);
  }

  patchInterest(id: number, input: Partial<SchoolInterestInput>) {
    return this.patch<SchoolInterest>(`${interests}${id}/`, input);
  }

  createActivity(id: number, input: SchoolInterestActivityInput) {
    return this.post<SchoolInterestActivity>(
      `${interests}${id}/activities/`,
      input,
    );
  }

  getCatalogs() {
    return this.get<SchoolInterestCatalogs>(`${interests}catalogs/`);
  }

  createLevel(input: SchoolInterestLevelInput) {
    return this.post<SchoolInterestLevel>(`${interests}levels/`, input);
  }

  patchLevel(id: number, input: Partial<SchoolInterestLevelInput>) {
    return this.patch<SchoolInterestLevel>(`${interests}levels/${id}/`, input);
  }

  createStage(input: SchoolInterestStageInput) {
    return this.post<SchoolInterestStage>(`${interests}stages/`, input);
  }

  patchStage(id: number, input: Partial<SchoolInterestStageInput>) {
    return this.patch<SchoolInterestStage>(`${interests}stages/${id}/`, input);
  }
}
